import React, { Component } from 'react'
import PropTypes from 'prop-types'
import SimpleMDE from 'react-simplemde-editor'
import { injectIntl, intlShape } from 'react-intl'

import MarkdownLabel from '../../mini/MarkdownLabel'
import NotYetSpecified from '../../mini/NotYetSpecified'
import ContentWarningsEditor from '../ContentWarningsEditor'
import ContentWarningsList from './contentwarnings/ContentWarningsList'
import P2 from '../../typography/paragraphs/P2'
import ErrorText from '../../typography/ErrorText'

import { simpleMDEOptions, isNullOrEmpty } from '../../../utils/index'
import {
  justFor,
  mentors,
  uploadAFile,
  uploadedFile,
  remove
} from '../../../utils/messages'
import { messages } from '../../../utils/messages/placeholder'
import { questHasContentWarnings } from '../../../utils/contentwarnings'
import { hasExpectedError } from '../../../utils/error'

class JustForMentors extends Component {
  state = {
    hasContentWarnings: questHasContentWarnings(this.props.quest),
    contentWarnings: this.props.quest.content_warnings
  }

  componentWillReceiveProps(nextProps) {
    // this component retains state between edits
    // need to reset the contentWarnings state to prevent "none" content warning radio on if previously selected
    if (!this.props.isEditing && nextProps.isEditing) {
      this.setState(() => ({
        contentWarnings: nextProps.quest.content_warnings
      }))
    }
  }

  render() {
    const {
      quest,
      questMentorNote,
      isUploadingNote,
      isDeletingNote,
      handleMentorNoteChange,
      onMentorFileUpload,
      handleMentorFileDescriptionChange,
      onDeleteQuestMentorNoteClick,
      handleChange,
      isEditing,
      intl,
      mentorNoteExists
    } = this.props

    const justForMentorsOptions = Object.assign({}, simpleMDEOptions)
    justForMentorsOptions.initialValue = quest.inline_mentor_notes
    justForMentorsOptions.placeholder = intl.formatMessage(
      messages.giveMentorsBackgroundInfo
    )
    justForMentorsOptions.autofocus = false

    const justForMentorsFileNoteOptions = Object.assign({}, simpleMDEOptions)
    justForMentorsFileNoteOptions.initialValue = questMentorNote
      ? questMentorNote.description
      : ''
    justForMentorsFileNoteOptions.placeholder = intl.formatMessage(
      messages.writeABriefDescriptionOfFile
    )
    justForMentorsFileNoteOptions.autofocus = false

    return (
      <div id="justForMentors" className="quest-level">
        <div className="just-for-mentors-label">
          {justFor}&nbsp;<span className="label">{mentors}</span>
        </div>

        <div id="mentorNoteRegion">
          {!isEditing && (
            <div className="view-fields">
              {quest.inline_mentor_notes &&
                quest.inline_mentor_notes.length > 0 && (
                  <MarkdownLabel
                    id="view-inline_mentor_notes"
                    value={quest.inline_mentor_notes}
                  />
                )}
            </div>
          )}
          {isEditing && (
            <div>
              <div className="edit-fields">
                <SimpleMDE
                  id="inlineMentorNotes"
                  options={justForMentorsOptions}
                  onChange={handleMentorNoteChange}
                />
              </div>
              <div className="file">
                {!isNullOrEmpty(questMentorNote) && !isDeletingNote && (
                  <div>
                    <div className="a-title edit-fields">{uploadedFile}</div>
                    <div className="a-title edit-fields editting">
                      <div
                        className={
                          'file-name name editting ' + questMentorNote.file_type
                        }
                      >
                        <a
                          className="editting"
                          href={questMentorNote.attachment_url}
                          target="_blank"
                        >
                          {questMentorNote.attachment_name}
                        </a>
                        <div
                          className="button remove-file edit-fields btn-destructive-small"
                          onClick={onDeleteQuestMentorNoteClick}
                        >
                          {remove}
                        </div>
                      </div>
                    </div>
                    <div className="file-description-wrapper">
                      <div className="title edit-fields" />
                      <div className="edit-fields">
                        <SimpleMDE
                          id="noteFileDescription"
                          options={justForMentorsFileNoteOptions}
                          onChange={handleMentorFileDescriptionChange}
                        />
                      </div>
                    </div>
                  </div>
                )}
                <div className="a-title edit-fields">
                  {!questMentorNote ? uploadAFile : ''}
                </div>
                {isNullOrEmpty(questMentorNote) &&
                  !isUploadingNote &&
                  !isDeletingNote && (
                    <div className="edit-fields">
                      <input
                        type="file"
                        id="mentorNoteFileInput"
                        onChange={onMentorFileUpload}
                      />
                      {mentorNoteExists && (
                        <div className="file-description-wrapper">
                          <div className="title edit-fields" />
                          <div className="edit-fields">
                            <SimpleMDE
                              id="noteFileDescription"
                              options={justForMentorsFileNoteOptions}
                              onChange={handleMentorFileDescriptionChange}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                {(isUploadingNote || isDeletingNote) && (
                  <div className="loading" />
                )}
              </div>
            </div>
          )}
          {!isEditing && !isNullOrEmpty(questMentorNote) && (
            <div id="mentorNoteRegion">
              <div className="file">
                <div className="view-fields">
                  <div
                    className={'file-name name ' + questMentorNote.file_type}
                  >
                    <a href={questMentorNote.attachment_url} target="_blank">
                      {questMentorNote.attachment_name}
                    </a>
                  </div>
                </div>
              </div>
              <div>
                {questMentorNote.description && (
                  <div className="view-fields">
                    <MarkdownLabel value={questMentorNote.description} />
                  </div>
                )}
              </div>
            </div>
          )}

          {isEditing && (
            <React.Fragment>
              <div className="title">Quest Content Warnings</div>
              <P2>
                Let mentors know that this quest contains sensitive topics or
                materials. &nbsp;
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://questforward.zendesk.com/hc/en-us/articles/360028989832"
                >
                  Learn more
                </a>
              </P2>
              <div className="content-warnings">
                <input
                  id="content-warnings-true"
                  type="radio"
                  checked={this.state.hasContentWarnings === true}
                  value={true}
                  onClick={this.onToggleContentWarningsClick}
                />
                <label htmlFor="content-warnings-true">Yes</label>
                <input
                  id="content-warnings-false"
                  type="radio"
                  checked={this.state.hasContentWarnings === false}
                  value={false}
                  onClick={this.onToggleContentWarningsClick}
                />
                <label htmlFor="content-warnings-false">No</label>
              </div>
              {this.state.hasContentWarnings && (
                <React.Fragment>
                  <ContentWarningsEditor
                    contentWarnings={this.state.contentWarnings}
                    handleContentWarningClick={this.onSetContentWarningClick}
                  />
                  {this.props.error &&
                    hasExpectedError(
                      this.props.error,
                      'content_warnings',
                      'content warnings required'
                    ) && (
                      <ErrorText style={{ marginTop: '24px' }}>
                        Select one or more content warnings.
                      </ErrorText>
                    )}
                </React.Fragment>
              )}
            </React.Fragment>
          )}
          {!isEditing && questHasContentWarnings(quest) && (
            <React.Fragment>
              <div className="title">Quest Content Warnings</div>
              <ContentWarningsList contentWarnings={quest.content_warnings} />
            </React.Fragment>
          )}
        </div>
      </div>
    )
  }

  onToggleContentWarningsClick = e => {
    const value = JSON.parse(e.target.value)
    this.setState(
      () => ({
        hasContentWarnings: value,
        contentWarnings: {}
      }),
      () => this.props.handleContentWarningsChange(this.state.contentWarnings)
    )
  }

  onSetContentWarningClick = e => {
    const name = e.target.name
    const value = e.target.value
    const checked = e.target.checked

    if (!value) {
      // for the 'none' radios/values
      this.setState(
        state => ({
          contentWarnings: {
            ...state.contentWarnings,
            [name]: null
          }
        }),
        () => {
          this.props.handleContentWarningsChange(this.state.contentWarnings)
        }
      )
      // don't love calling risky_behaviors directly here - should be able to handle other potential new values
    } else if (name !== 'risky_behaviors') {
      if (checked) {
        this.setState(
          state => ({
            contentWarnings: {
              ...state.contentWarnings,
              [name]: { value: value }
            }
          }),
          () => {
            this.props.handleContentWarningsChange(this.state.contentWarnings)
          }
        )
      } else {
        // Need to handle graphic_content, is only one with a input checkbox for 'none' value
        this.setState(
          state => ({
            contentWarnings: {
              ...state.contentWarnings,
              [name]: null
            }
          }),
          () => {
            this.props.handleContentWarningsChange(this.state.contentWarnings)
          }
        )
      }
    } else {
      // for the risky_behaviors - need to handle differently
      checked
        ? this.setState(
            state => ({
              contentWarnings: {
                ...state.contentWarnings,
                [name]: state.contentWarnings[name]
                  ? state.contentWarnings[name].concat({ value: value })
                  : [{ value: value }]
              }
            }),
            () => {
              this.props.handleContentWarningsChange(this.state.contentWarnings)
            }
          )
        : this.setState(
            state => ({
              contentWarnings: {
                ...state.contentWarnings,
                [name]: state.contentWarnings[name].filter(
                  cw => cw.value !== value
                )
              }
            }),
            () => {
              this.props.handleContentWarningsChange(this.state.contentWarnings)
            }
          )
    }
  }
}

JustForMentors.propTypes = {
  quest: PropTypes.object.isRequired,
  questMentorNote: PropTypes.object,
  isUploadingNote: PropTypes.bool.isRequired,
  isDeletingNote: PropTypes.bool.isRequired,
  handleMentorNoteChange: PropTypes.func.isRequired,
  onMentorFileUpload: PropTypes.func.isRequired,
  handleMentorFileDescriptionChange: PropTypes.func.isRequired,
  onDeleteQuestMentorNoteClick: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
  isEditing: PropTypes.bool.isRequired,
  mentorNoteExists: PropTypes.bool.isRequired,
  handleContentWarningsChange: PropTypes.func.isRequired,
  error: PropTypes.object
}

export default injectIntl(JustForMentors)
export { JustForMentors as JustForMentorsDisconnected }



// WEBPACK FOOTER //
// ./src/components/quest/basicinformation/JustForMentors.js